window._ = require('lodash');
$ = require('jquery');
window.$ = window.jQuery = $;

(function ($) {
    ("use strict");

    $(document).ready(function(){
        window.submitRegister = function () {
            var forms = document.querySelectorAll('#registerUserForm');
            var validationForm = true;
            Array.prototype.slice.call(forms)
                .forEach(function (form) {
                    if (!form.checkValidity()) {
                        validationForm = false;
                    }
                    form.classList.add('was-validated')
                });

            if (!validationForm) {
                return false;
            }

            var username = document.getElementById('username');
            var email = document.getElementById("email");
            var password = document.getElementById("password");
            var password_confirmation = document.getElementById("password_confirmation");
            if (password.value !== password_confirmation.value) {
                toastr.error("Las contraseñas no coinciden");
                return false;
            }

            var user = {
                'username': username.value,
                'email': email.value,
                'password': password.value,
                'password_confirmation': password_confirmation.value,
                'recaptchaToken' : ''
            }

            grecaptcha.ready(function() {
                grecaptcha.execute('6LcUjc8jAAAAAKelfUx9MU-TGyQIEPw7Gy3oI-Bn', {action: 'registerUser'})
                    .then(function(token) {
                        user.recaptchaToken = token;
                        $.ajax({
                            method: "POST",
                            url: "/register",
                            data: user,
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            },
                            success: function(response){
                                if (response.result) {
                                    toastr.success("Registrado con éxito");
                                    location.href ="/login";
                                } else {
                                    toastr.warning("Error al registrar usuario");
                                }

                            },
                            error: function(msg) {
                                toastr.warning(msg.responseJSON.response);
                                console.log("error", msg.responseJSON.response);
                            }
                        });
                    });
            });
        }

        window.submitLogin = function (type) {
            var forms = document.querySelectorAll('#loginForm');
            var validationForm = true;
            Array.prototype.slice.call(forms)
                .forEach(function (form) {
                    if (!form.checkValidity()) {
                        validationForm = false;
                    }
                    form.classList.add('was-validated')
                });

            if (!validationForm) {
                return false;
            }

            var email = document.getElementById("email");
            var password = document.getElementById("password");

            var user = {
                'email': email.value,
                'password': password.value
            }
            $.ajax({
                method: "POST",
                url: "/login",
                data: user,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function(response){
                    if (response) {
                        if (type && type === 'cart'){
                            location.reload();
                        } else {
                            location.href ="/";
                        }
                    } else {
                        toastr.error("Correo y/o Contraseña incorrectos");

                    }
                },
                error: function(msg) {
                    console.log("error", msg);
                }
            });
        }

        window.submitRestorePassword = function () {

            var forms = document.querySelectorAll('#restorePassForm');
            var validationForm = true;
            Array.prototype.slice.call(forms)
                .forEach(function (form) {
                    if (!form.checkValidity()) {
                        validationForm = false;
                    }
                    form.classList.add('was-validated')
                });

            if (!validationForm) {
                return false;
            }

            var password = document.getElementById("password");
            var password_confirmation = document.getElementById("password_confirmation");
            if (password.value !== password_confirmation.value) {
                toastr.error("Las contraseñas no coinciden");
                return false;
            }

            var formOrder = document.getElementById('restorePassForm');
            $.ajax({
                method: "POST",
                url: "/account/restorepassword",
                data: new FormData(formOrder),
                processData: false,
                contentType: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function(response){
                    if (response.result) {
                        toastr.success("Contraseña cambiada");
                        location.href = "/login";
                    } else {
                        toastr.error("Error al restaurar contraseña");
                    }
                },
                error: function(msg) {
                    toastr.warning(msg.responseJSON.response);
                    console.log("error", msg);
                }
            });
        }

        window.submitChangePassword = function () {

            var forms = document.querySelectorAll('#changePasswordForm');
            var validationForm = true;
            Array.prototype.slice.call(forms)
                .forEach(function (form) {
                    if (!form.checkValidity()) {
                        validationForm = false;
                    }
                    form.classList.add('was-validated')
                });

            if (!validationForm) {
                return false;
            }

            var password = document.getElementById("password");
            var password_confirmation = document.getElementById("password_confirmation");
            if (password.value !== password_confirmation.value) {
                toastr.error("Las contraseñas no coinciden");
                return false;
            }

            var formOrder = document.getElementById('changePasswordForm');
            $.ajax({
                method: "POST",
                url: "/account/changepassword",
                data: new FormData(formOrder),
                processData: false,
                contentType: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function(response){
                    if (response.result) {
                        toastr.success("Contraseña cambiada");
                        location.reload();
                    } else {
                        toastr.error("Error al cambiar contraseña");
                    }
                },
                error: function(msg) {
                    toastr.warning(msg.responseJSON.response);
                    console.log("error", msg);
                }
            });
        }
        window.submitUpdateAccount = function () {

            var forms = document.querySelectorAll('#updateAccountForm');
            var validationForm = true;
            Array.prototype.slice.call(forms)
                .forEach(function (form) {
                    if (!form.checkValidity()) {
                        validationForm = false;
                    }
                    form.classList.add('was-validated')
                });

            if (!validationForm) {
                return false;
            }

            var formOrder = document.getElementById('updateAccountForm');
            $.ajax({
                method: "POST",
                url: "/account",
                data: new FormData(formOrder),
                processData: false,
                contentType: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function(response){
                    if (response.result) {
                        toastr.success("Datos actualizados");
                        location.reload();
                    } else {
                        toastr.error("Error al actualizar datos");
                    }
                },
                error: function(msg) {
                    toastr.warning(msg.responseJSON.response);
                    console.log("error", msg);
                }
            });
        }
    });

})(jQuery);
